'use strict';

import React, { Component, Fragment } from 'react';
//import { View, Text, Platform } from 'react-native';
//import {em, sizeResponsive} from "../utils/FWResponsive";
import { connect } from 'react-redux';

import { platformHandler } from '../platforms/PlatformHandler'
import { COLOR, FONT_FAMILY, TEXT_SIZES }     from '../App/constants';
//import { IconToggle, themes,} from 'carbon-ui'
import AlarmIcon from '@material-ui/icons/Alarm';


class Clock extends Component {

  constructor(props) {
      super(props);       
  }

  componentDidMount() {
    platformHandler.setListenerPresentationClock( this.timeChange.bind(this) ); 
  }

  componentWillUnmount() {
    platformHandler.setListenerPresentationClock( null ); 
  }

  timeChange( data ){
    //this.timeChangeInt( data );  
    if( data ){
      this.setState({ form: { ...this.state.form, ["time"]: data }})      
    }
  }
  
  static propTypes = {
     //dispatch: React.PropTypes.func.isRequired
   }

  state = {
    form: {
      time: '00:00',
    }
  }

  askRestartClock = () => {
    console.log('HOLA');
    this.props.askRestartClock();
  }

  restartClock(){
    platformHandler.restartClock();
  }
  
  render() {      
    return (
      <React.Fragment>
        <div style={styles.alarmIconDiv} onClick={this.askRestartClock}>
          <AlarmIcon style={{marginRight:5}}/>
          {this.state.form.time}
        </div>        
      </React.Fragment>
    );
  }; 
}

export default connect()(Clock);

const styles = {

  alarmIconDiv: {
    height: '100%',
    display: 'flex',
    alignItems: 'center', 
    fontSize: '1.1em',
    fontFamily: 'Roboto-Medium',
    cursor: 'pointer',
  },

  timePresentation: {
      color: COLOR.TEXT,
      fontSize: TEXT_SIZES.TEXT,
      fontFamily: FONT_FAMILY,
      textAlign: 'center',
  },  

  timeSlide: {
    position:'absolute',
    flexDirection: 'row',
    bottom: 0,
    left: 0,
    top: 0,
    
  },

  bgClock: {
    backgroundColor: 10,
    width:10,
    justifyContent: 'center',
    alignItems: 'center',
  },

  bgTime: {
    backgroundColor: 10,
    borderWidth: 0.5,
    borderColor: 10,
    width:18,
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const stylesCarbon = {

  clock: {
    color: COLOR.TEXT_WHITE,
      fontSize: TEXT_SIZES.CLOCK,
      textAlign: 'left',
      //paddingRight: sizeResponsive(1),
  },  
};




// WEBPACK FOOTER //
// ./src/containers/components/Clock.js